/**
 * @fileoverview Styles for the ResendPhoneVerification component renderer.
 * This module contains styles for the phone verification resend link and associated text elements.
 *
 * @example
 * // Usage in component:
 * import styles from './ResendPhoneVerificationRenderer.module.css'
 *
 * <button className={styles.link}>Resend code</button>
 * <span className={styles.prefix}>Haven't received the code? </span>
 * <span className={styles.text}>Please wait 60 seconds</span>
 */


.link {
    color: var(--indigo700);
    max-width: fit-content;
    text-decoration: none;
    cursor: pointer;
    background: none;
    border: none;
    text-decoration: underline;
    text-underline-offset: 3px;

    font-weight: 300;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: -0.017em;
    margin: 0;
    padding: 0;
    outline: none;
    border-radius: 0.75rem;
    transition: all 200ms ease-out;
}

.link:active {
    text-decoration: underline;
}

.prefix,
.text {
    font-weight: 300;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: -0.017em;
    color: var(--neutural500);
    margin: 0;
}

.prefix {
    color: var(--neutural900);
}
